/**
 * Folds a content line to the 75-byte limit that calendar (.ics, RFC 5545
 * 3.1) and contact (.vcf, RFC 6350 3.2) files expect: continuation lines
 * start with a space. A long link or address can pass the limit, and some
 * apps cut or drop a longer line.
 */
export function foldContentLine(line: string): string {
  const encoder = new TextEncoder()
  const parts: string[] = []
  let current = ''
  let bytes = 0
  for (const char of line) {
    const size = encoder.encode(char).length
    const limit = parts.length === 0 ? 75 : 74
    if (bytes + size > limit) {
      parts.push(current)
      current = ''
      bytes = 0
    }
    current += char
    bytes += size
  }
  parts.push(current)
  return parts.join('\r\n ')
}
